/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import AuthService from '@/services/AuthService';
import StorageService from '@/services/StorageService';
import axios from 'axios';

const state = () => ({
    token: null,
    accessToken: null,
    expiresAt: null,
    user: null,
    userId: null,
    role: null
});

const getters = {

};

const mutations = {
    setToken(state, value) {
        state.token = value;
        if (value) {
            localStorage.setItem('refresh_token', value);
        } else {
            localStorage.removeItem('refresh_token');
        }
    },
    setAccessToken(state, value) {
        state.accessToken = value;
        // if (value) {
        //     localStorage.setItem('access_token', value);
        // } else {
        //     localStorage.removeItem('access_token');
        // }
    },
    setExpiresAt(state, value) {
        const expiresAt = (typeof value !== 'string') ? JSON.stringify(value) : value;
        state.expiresAt = expiresAt;
        if (value) {
            localStorage.setItem('expires_at', expiresAt);
        } else {
            localStorage.removeItem('expires_at');
        }
    },
    setRole(state, value) {
        state.role = value;
        if (value) {
            localStorage.setItem('role', value);
        } else {
            localStorage.removeItem('role');
        }
    },
    setUser(state, value) {
        state.user = value;
        if (value) {
            localStorage.setItem('user', JSON.stringify(value));
        } else {
            localStorage.removeItem('user');
        }
    },
    setCourse(state, value) {
        state.course = value || null;
        StorageService.setCourse(value);
    },
};

const actions = {
    loadStorage({ commit }) {
        commit('setToken', localStorage.getItem('refresh_token'));
        // commit('setAccessToken', localStorage.getItem('access_token'));
        commit('setCourse', StorageService.getCourse());
        commit('setExpiresAt', localStorage.getItem('expires_at'));
        commit('setRole', localStorage.getItem('role'));
        const user = localStorage.getItem('user');
        if (user) {
            commit('setUser', JSON.parse(localStorage.getItem('user')));
        }
    },
    refresh({ state, commit }) {
        return AuthService.getRefreshToken({
            refreshToken: state.token
        })
            .then(({ data }) => {
                if (data && data.access_token && data.refresh_token) {
                    commit('setExpiresAt', data.expires_in * 1000 + new Date().getTime());
                    commit('setRole', data.role);
                    commit('setAccessToken', data.access_token);
                    commit('setToken', data.refresh_token);
                    commit('setUser', {
                        email: data.userName,
                        claims: { isAdmin: data.isAdmin, isSignee: data.isSignee },
                    });
                    axios.defaults.headers.common.Authorization = `${data.token_type} ${data.access_token}`;
                    return data.access_token;
                }
                return null;
            })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
